import { Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';
import styles from './Filter.module.scss';
import { Button, ButtonProps } from 'ui/components/1-atoms/Action/Button/Button';

export interface FilterProps {
	items: ButtonProps[];
}

export const Filter: React.FC<FilterProps> = ({ items }) => {
	return !items?.length ? (
		<Spinner />
	) : (
		<div className={styles.Filter}>
			{items.map((item, index) => (
				<Button style="filter" key={index} {...item}>
					{item.children}
				</Button>
			))}
		</div>
	);
};
